import { render } from "./changepwd.vue?vue&type=template&id=a942b224"
import script from "./changepwd.vue?vue&type=script&lang=js"
export * from "./changepwd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/changepwd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a942b224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a942b224', __exports__)) {
    console.log('reload')
    api.reload('a942b224', __exports__)
  }
  
  module.hot.accept("./changepwd.vue?vue&type=template&id=a942b224", () => {
    console.log('re-render')
    api.rerender('a942b224', render)
  })

}


export default __exports__